import React from 'react';
import { 
  Typography,
  Box,
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText,
  useTheme,
  useMediaQuery
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import successImage from '../../../../assets/images/marketing/achieve-success-ad-picture.png';

const listItems = [
  {
    text: 'View your child\'s matches and see how the return on investment looks for them personally.'
  },
  {
    text: 'Give your child access to our AI guidance counselor and their personal counselors to get a path forward for their education and career.'
  },
  {
    text: 'A checklist of the steps your child needs to take to get into their dream school and career.'
  },
  {
    text: 'And much more!'
  }
];

export const ParentsContent = ({user}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery('(min-width:950px)');

  return (
    <React.Fragment>
      <Box p={2} sx={{ position: 'relative', height: '100%' }}>
        <Box sx={{ position: 'relative', zIndex: 1, height: '100%' }}>
          {user.educator_count > 0 ? (
            <>
              <Typography variant="h4" component="div" color='primary' sx={{ mb: 1 }}>Sign Up Is Required To Continue!</Typography>
              <Typography variant="h6" component="div" color='secondary'>Sign up to gain access OR if you had access before, check your educators accounts to make sure they have your child added. You can regain access through them!</Typography>
            </>
          ) : (
            <>
              <Typography variant="h4" component="div" color='primary' sx={{ mb: 1 }}>Your Roadmap To Success Is Ready!</Typography>
              <Typography variant="h6" component="div" color='secondary'>Subscribe to your 7 day free trial to give you and your child access to everything that Education Advisor has to offer! No commitment, cancel anytime.</Typography>
            </>
          )}
          <List sx={{ p: 0 }}>
            {listItems.map((item, index) => (
              <ListItem key={index} sx={{ pl: 0, alignItems: 'flex-start' }}>
                <ListItemIcon sx={{ minWidth: 0, mr: 1, mt: 1 }}>
                  <CheckCircleIcon color="primary" fontSize='small' />
                </ListItemIcon>
                <ListItemText>
                  <Typography component="p" color='secondary'>
                    {item.text}
                  </Typography>
                </ListItemText>
              </ListItem>
            ))}
          </List>
        </Box>
        {isDesktop && (
          <Box sx={{ 
            position: 'absolute',
            bottom: 0,
            right: '80px',
            width: '200px',
            height: 'auto',
            zIndex: 0,
            overflow: 'visible'
          }}>
            <img 
              src={successImage} 
              alt="Achieve Success" 
              style={{ 
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                marginTop: '-220px',
                display: 'block'
              }} 
            />
          </Box>
        )}
      </Box>
    </React.Fragment>
  );
};